export const FirstFoolList=[
    {
        id: 1,
        title: "Car Drive",
        image: require('../images/a-simple-abstract-car-steering-wheel-hands-drivin-2025-01-26-23-48-58-utc.jpg'),
        description: "اختبر مهاراتك في العالم  المثير مع لعبة سياقة السيارات المحاكي التفاحيط: تحكم بسيارتك باحترافية، تَحدَّى المنعطفات الصعبة، واستمتع بتجربة واقعية تدمج بين الإثارة والدقة الفنية!"
      },
      {
        id: 2,
        title: "Real Car Drive",
        image: require('../images/the-man-drive-with-a-navigation-on-the-highway-in-2024-12-05-00-00-11-utc.jpg'),
        description: "تجربة قيادة حقيقية من داخل هيكل سيارة رباعية الدفع لتخوض بسباق محاكي بالواقع المعزز "
      },
      {
        id: 3,
        title: "PS5",
        image: require('../images/composite-of-computer-with-video-game-accessories-2025-04-03-16-05-42-utc.jpg'),
        description: "غوص في عالم الألعاب الثوري مع بلايستيشن 5: تجربة بصرية مذهلة، أداء خارق، ومكتبة حصرية تضع ملحمة المتعة بين يديك!"
      },
      {
        id: 4,
        title: "Computer Gamings",
        image: require('../images/composite-of-computer-keyboard-with-video-game-ac-2025-04-03-08-20-14-utc.jpg'),
        description: "انطلق في رحلة لا تُنسى مع ألعاب الكمبيوتر: جرّب تحديات استراتيجية ملحمية، مغامرات غامرة بجرافيكس مذهل، و عوالم مفتوحة تمنحك حرية الإبداع والتنافس، كل ذلك على شاشة واحدة!"
      }
]

export const secondFoolList=[
    {
        id: 1,
        title: "لعبة البوكسنج",
        image: require('../images/poxing.jpg'),
        description: "  في لعبة البوكسنج تحدى اصدقائك واختبر مدى قوتك وسجل ارقاما قياسية"
      },
      {
        id: 2,
        title: "PS5",
        image: require('../images/game-controller-with-with-lights-fog.jpg'),
        description: "اختبر ملحمة متعة لا تُضاهى مع بلايستيشن 5!"
      },
      {
        id: 3,
        title: "لعبة البلوت",
        image: require('../images/view-casino-gambling-cards.jpg'),
        description: "خُض تحديًا ذهنيًّا مشتعلًا مع لعبة البلوت!"
      },
      {
        id: 4,
        title: "لعبة البلياردوا",
        image: require('../images/view-surface-billiard-table-balls.jpg'),
        description: "افخم طاولات البلياردو التي قامت  بها مسابقات عالمية"
      },{
        id: 5,
        title: "لعبة جاكارو",
        image: require('../images/jakaro.jpg'),
        description: "اختبر إثارة التكتيك والحظ في لعبة الجاكارو الشهيرة! 🎲✨"
      },
      {
        id: 6,
        title: "العاب طاولة",
        image: require('../images/party-dominoes-cup-hot-tea.jpg'),
        description: "استمتع بكل لحظة وتغلب على منافسينك"
      },
      {
        id: 6,
        title: "العاب طاولة",
        image: require('../images/high-angle-view-multi-colored-pencils-table.jpg'),
        description: "لعبة المتعة والتوتر والاتقان"
      },
]


export const coffeeShopFoolList=[
  
   
   
   
    
  
    
    {
      id: 8,
      title: "قهوة مختصة",
      image: require('../images/قهوة مختصة.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    ,
    {
      id: 9,
      title: "كركدية",
      image: require('../images/كركدية.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    ,
    {
      id: 10,
      title: "ايس شوكلت",
      image: require('../images/ايس شوكلت.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    ,
    {
      id: 7,
      title: "ايس لاتيه",
      image: require('../images/ايس لاتيه.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    ,
    {
      id: 8,
      title: " لاتيه",
      image: require('../images/لاتيه2.jpeg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    ,
    {
      id: 11,
      title: "ايس سبانش لاتيه",
      image: require('../images/ايس سبنش لاتيه.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    ,
    {
      id: 12,
      title: "ايس V60",
      image: require('../images/ايس 60.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    {
      id: 13,
      title: "ايس وايت موكا",
      image: require('../images/ايس وايت موكا.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    {
      id: 17,
      title: "كوكيز - فانيليا - شوكولاته",
      image: require('../images/كوكيز.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    {
      id: 18,
      title: "ايس تي - خوخ - باشن فروت",
      image: require('../images/ايس تي خوخ.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    {
      id: 19,
      title: "دبل اسبريسو",
      image: require('../images/دبل اسبريسو.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    
    {
      id: 32,
      title: "موهيتو",
      image: require('../images/موهيتو.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    {
      id: 33,
      title: "كبتشينو",
      image: require('../images/كبتشينو.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    
]
export const thirdFloorList=[
  
    {
      id: 2,
      title: "تنس",
      image: require('../images/تنس2.jpg'),
      description: "جـزءاً مـن حـكـايـتـنـا، وَتـسـتـلـهـمـوا مـنـا لـحـظـاتٍ تـصـنـعُ ذكـريـاتٍ تـعـانـقُ الـأبـد."
    },
    {
      id: 1,
      title: "غرف VIP",
      image: require('../images/WhatsApp Image 2025-04-22 at 6.16.38 PM.jpeg'),
      description: "شاشة لمتابعة الافلام والمسلسلات - مبارايات-PS5-طاولات بلوت-طاولات جاكارو"
    },
    
   
]

export const AboutUsImagesList=[
  {
    imgage:require('../images/billiyard poster .jpg')
  },
  {
    imgage:require('../images/من نحن-01.jpg')
  },
  {
    imgage:require('../images/view-surface-billiard-table-balls.jpg')
  },
  {
    imgage:require('../images/1745306984342.jpg')
  },
  {
    imgage:require('../images/1745306785305.jpg')
  }
]